import SearchCollection from './SearchCollection';

export default SearchCollection;
